import { Box, Popover, Typography } from "@mui/material";
import React from "react";
import CustomTextField from "../../../../components/ui/Textfield";

export interface ChurchDetails {
  churchName: string;
  address: string;
  suburb: string;
}

interface ChurchLocationPickerProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  value: ChurchDetails;
  onChange: (details: ChurchDetails) => void;
}

const ChurchLocationPicker: React.FC<ChurchLocationPickerProps> = ({
  open,
  anchorEl,
  onClose,
  value,
  onChange,
}) => {
  const handleFieldChange = (field: keyof ChurchDetails, newValue: string) => {
    onChange({
      ...value,
      [field]: newValue,
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (value.churchName && value.address && value.suburb) {
        onClose();
      }
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: { xs: 3, md: 4 },
          p: { xs: 2, md: 2.5 },
          width: { xs: 320, md: 380 },
          maxHeight: { xs: "100%", lg: 400 },
          mt: 1,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        },
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontSize: { xs: "0.938rem", md: "1rem" },
          fontWeight: 600,
          mb: 2,
        }}
      >
        Enter Church Information
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <CustomTextField
          label="Church Name"
          value={value.churchName}
          onChange={(e) => handleFieldChange("churchName", e.target.value)}
          onKeyDown={handleKeyDown}
          required
        />

        <CustomTextField
          label="Address"
          value={value.address}
          onChange={(e) => handleFieldChange("address", e.target.value)}
          onKeyDown={handleKeyDown}
          required
        />

        <CustomTextField
          label="Suburb"
          value={value.suburb}
          onChange={(e) => handleFieldChange("suburb", e.target.value)}
          onKeyDown={handleKeyDown}
          required
        />
      </Box>
    </Popover>
  );
};

export default ChurchLocationPicker;
